import type { FC } from "react";
import { HeadingLevel, Layout } from "@viagogo/core/ui";
import { Feature, RemoveFeature } from "@viagogo/feature";
import { Content } from "src/shared/components/content";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import { useAppContext } from "src/shared/context/AppContext";
import { DownloadApps } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/DownloadApps";
import { GivingBack } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/GivingBack";
import { JoinUs } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/JoinUs";
import { MetricsBanner } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/MetricsBanner";
import { Partners } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/Partners";
import { Promise } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/Promise";
import {
  StyledTextDiv,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { TeamCaptain } from "src/website-apps/responsive/stubhub-about-us/components/stubhub/TeamCaptain";
import { useAboutUsPageModelData } from "src/website-apps/responsive/stubhub-about-us/hooks/useAboutUsPageModelData";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";
import { LazyFooter } from "src/website-apps/shared/components/footer";
import { HeaderConfiguration } from "src/website-apps/shared/components/header";
import { TitleBanner } from "src/website-apps/shared/components/TitleBanner/TitleBanner";
import { useOsHint } from "src/website-apps/shared/utils/isNative";
import { removeMobileAppDownloadBanners } from "./utils";

const CompanyDescription = () => (
  <StyledTextDiv>
    <Content id="cid$#1937267#" />
  </StyledTextDiv>
);

export const App: FC = () => {
  const appContext = useAppContext();
  const model = useAboutUsPageModelData();
  const osHint = useOsHint(appContext);
  return (
    <HeadingLevel>
      <Layout
        header={<HeaderConfiguration.Simple />}
        body={
          <>
            <TitleBanner title={<Content id="cid$#1053486#" />} />
            <TextWrapper>
              <StyledTitle>
                <Content id="cid$#1906536#" />
              </StyledTitle>
              <CompanyDescription />
            </TextWrapper>
            <Promise images={model.promiseImagesUrl ?? []} />
            <Partners />
            <MetricsBanner />
            <TeamCaptain image={model.teamCaptainImageUrl ?? ""} />
            <GivingBack images={model.givingBackImagesUrl ?? []} />
            <JoinUs images={model.joinUsImagesUrl ?? []} />
            <RemoveFeature
              id={FeatureSetEnum.nWebHideAppDownloadBanner}
              feature={() => (
                <Feature
                  id={FeatureSetEnum.mWebHideAppDownloadBanner}
                  control={() => <DownloadApps images={model.downloadImagesUrl} links={model.downloadLinks ?? []} />}
                  variant={() => {
                    removeMobileAppDownloadBanners(appContext, model, osHint);
                    return <DownloadApps images={model.downloadImagesUrl} links={model.downloadLinks ?? []} />;
                  }}
                />
              )}
            />
          </>
        }
        footer={
          <LazyFooter
            companyLinks={model.footer.companyLinks}
            supportLinks={model.footer.supportLinks}
            getLocationSettingsUrl={model.footer.getLocationSettingsUrl}
          />
        }
      />
    </HeadingLevel>
  );
};
